import { Component, OnInit } from '@angular/core';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { MenuService } from 'src/app/services/menu.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomErrorStateMatcher } from '../../validators/state-matcher/custom-error-state-matcher';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-change-pass',
    templateUrl: './change-pass.component.html',
    styleUrls: ['./change-pass.component.css']
  })
  export class ChangePassComponent implements OnInit {

    userId: number;

    constructor(
      private menuService: MenuService,
      private authService: AuthService,
      private router: Router ) {

        this.menuService.setMenuTitle('Cambio de contraseña');
    }

    ngOnInit(): void {

    }

    onPassChanged( event )  {
      this.router.navigate(['home']);
    }

  }
